const PERSONAL_PROFILE_FIELDS = ["firstName", "lastName", "email", "mobile"];
const PERSON_BACKED_ROLE_TABLES = ["clients", "students", "teachers"];
const ROLE_PERSON_ID_PREFIXES = {
  clients: "client",
  students: "student",
  teachers: "teacher",
};

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object || {}, key);

function isPersonBackedRoleTable(tableName) {
  return PERSON_BACKED_ROLE_TABLES.includes(tableName);
}

function buildPersonId(roleId, roleTableName) {
  const rolePrefix = ROLE_PERSON_ID_PREFIXES[roleTableName];
  if (!rolePrefix) {
    throw new Error("Cannot build personId without role table");
  }
  const scopedRoleId = String(roleId).startsWith(`${rolePrefix}-`)
    ? roleId
    : `${rolePrefix}-${roleId}`;
  return `person-${scopedRoleId}`;
}

function resolvePersonId(role = {}, roleTableName) {
  if (role.personId) return role.personId;
  if (role.id === undefined || role.id === null) {
    throw new Error("Cannot build personId without role id");
  }
  return buildPersonId(role.id, roleTableName);
}

function pickPersonalFields(record = {}) {
  return PERSONAL_PROFILE_FIELDS.reduce((fields, field) => (
    hasOwn(record, field) ? { ...fields, [field]: record[field] } : fields
  ), {});
}

function stripPersonalFields(record = {}) {
  return Object.keys(record).reduce((nextRecord, key) => (
    PERSONAL_PROFILE_FIELDS.includes(key) ? nextRecord : { ...nextRecord, [key]: record[key] }
  ), {});
}

function hasPersonalField(record = {}) {
  return PERSONAL_PROFILE_FIELDS.some(field => hasOwn(record, field));
}

function buildPersonFromRole(role = {}, roleTableName) {
  const personId = resolvePersonId(role, roleTableName);
  return {
    id: personId,
    ...pickPersonalFields(role),
  };
}

function roleWithPersonId(role = {}, roleTableName) {
  return stripPersonalFields({
    ...role,
    personId: resolvePersonId(role, roleTableName),
  });
}

function decorateRoleWithPerson(role = {}, person = null) {
  if (!person) return role;
  return {
    ...role,
    email: '',
    mobile: '',
    ...pickPersonalFields(person),
  };
}

function decorateRolesWithPeople(roles = [], people = []) {
  const peopleById = people.reduce((index, person) => ({
    ...index,
    [person.id]: person,
  }), {});
  return roles.map(role => decorateRoleWithPerson(role, peopleById[role.personId]));
}

module.exports = {
  PERSONAL_PROFILE_FIELDS,
  PERSON_BACKED_ROLE_TABLES,
  ROLE_PERSON_ID_PREFIXES,
  buildPersonFromRole,
  buildPersonId,
  decorateRolesWithPeople,
  decorateRoleWithPerson,
  hasPersonalField,
  isPersonBackedRoleTable,
  pickPersonalFields,
  roleWithPersonId,
  stripPersonalFields,
};
